import React from 'react';
import { bool, func, string } from 'prop-types';
import { Box, Button, Card, Tooltip, Typography } from '@mui/material';
import { DropletRounded } from 'library';

const cardContentWrapper = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  padding: 0,
};

const cardWrapper = theme => ({
  boxShadow: theme.shadows[5],
  maxHeight: 291,
  width: 304,
});

const dropletIcon = theme => ({
  color: theme.palette.primary.dark,
  height: 90,
  width: 90,
});

const startButtonStyles = { width: 130 };

const SubscriptionCard = props => {
  const { onClick, title, hasSubscriberPermissions, noPermissionButtonTooltipText } = props;

  return (
    <Card sx={cardWrapper}>
      <Box sx={cardContentWrapper}>
        <Typography sx={{ px: 0, py: 2 }} variant="h6">
          {title}
        </Typography>
        <Box
          alignItems="center"
          bgcolor="graphic.lighter"
          display="flex"
          height="144px"
          justifyContent="center"
          width="100%"
        >
          <DropletRounded sx={dropletIcon} />
        </Box>
        <Box alignItems="center" display="flex" height="84px" justifyContent="center">
          {hasSubscriberPermissions ? (
            <Button onClick={onClick} sx={startButtonStyles}>
              Get Started
            </Button>
          ) : (
            <Tooltip
              enterTouchDelay={10}
              placement="bottom"
              slotProps={{
                popper: { sx: { textAlign: 'center' } },
              }}
              title={noPermissionButtonTooltipText}
            >
              <Box>
                <Button disabled={!hasSubscriberPermissions} onClick={onClick}>
                  Get Started
                </Button>
              </Box>
            </Tooltip>
          )}
        </Box>
      </Box>
    </Card>
  );
};

SubscriptionCard.propTypes = {
  hasSubscriberPermissions: bool.isRequired,
  noPermissionButtonTooltipText: string.isRequired,
  onClick: func.isRequired,
  title: string.isRequired,
};

export default SubscriptionCard;
